module.exports = __webpack_public_path__ + "img/7272aea596e9825bbd4f681ef9ba4c4f.png";